// extracted by mini-css-extract-plugin
export var mediaElement = "mockup-imac-module--mediaElement--1ef03";
export var mockImage = "mockup-imac-module--mockImage--b4816";
export var mockup = "mockup-imac-module--mockup--e00fb";